<template>
    <div class="tx-history-wrap">
        <table class="ui-table">
            <thead>
                <tr>
                    <th>{{ $t('common.address') }}</th>
                    <th>{{ $t('address.info.balance') }}</th>
                </tr>
            </thead>
            <tbody v-for="item in holders" v-bind:key="`lockerHolder_${item.address}`">
                <tr>
                    <td>
                        <ui-address v-bind:address="item.address" />
                    </td>
                    <td>
                        {{ $ton(item.balance) }} TON
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import lockerHolders from '../../../json/lockerHolders.json';

export default {
    data() {
        return {
            holders: lockerHolders,
        };
    },
};
</script>

<style scoped lang="scss">

</style>
